export default __webpack_public_path__ + "static/media/maithili_lang.7f6e7ed3.png";